
import React from 'react'

function ErrorLogin() {
  return (
    <div>
  <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
  <title>Dropbox - 400</title>
  <link href="https://cfl.dropboxstatic.com/static/metaserver/static/css/error.css" rel="stylesheet" type="text/css" />
  <link rel="shortcut icon" href="https://cfl.dropboxstatic.com/static/images/favicon.ico" />
  <div className="figure">
    <img src="https://cdn-icons-png.flaticon.com/512/6380/6380220.png" alt="Error: 4xx" />
  </div>
  <div id="errorbox">
    <div className="not-found"> <h1>Error (400)</h1>No se puede obtener la informacion, ya que el usuario no existe en la herramienta. Por favor contacte al administrador del sistema</div>
  </div>
</div>
  )
}

export default ErrorLogin

